<template>
  <label>
    <input type="radio" :name="name" :value="value" v-model="radioButtonValue"/>
    <div class="uk-card uk-card-default uk-card-hover uk-border-rounded uk-box-shadow-small">
      <div class="uk-card-body">
        <div class="uk-grid-small uk-text-center" uk-grid>
          <div class="uk-width-1-1 uk-flex uk-flex-center">
            <!-- <BitOSIcon :icon="os.name" height="72" width="55.2" /> -->
            <BitOSIcon :icon="os.name" height="80" width="80" />
          </div>
          <div class="uk-width-1-1">
            <h3>{{ os.title }}</h3>
          </div>
        </div>
      </div>
      <div class="uk-card-footer uk-padding-remove">
        <!-- dropdown selector for multiple versions, default the first index -->
        <div class="uk-width-expand" uk-form-custom="target: > * > span:first-child" v-if="os.versions.length > 1">
          <select class="uk-select" @change="onVersionChange()" v-model="selectedVersion">
            <option v-for="(version, index) in os.versions" :key="index" :value="version"> {{ version.v }}</option>
          </select>
          <BitButton color="transparent" class="uk-flex-center">
            Version: <span></span>
            <span class="ba-chevron-fix uk-flex-right uk-margin-small-left" uk-icon="icon: chevron-down; ratio: 1.15"></span>
          </BitButton>
        </div>

        <div class="uk-width-expand" v-else>
          <div class="single-version uk-width-1-1 uk-flex-center">
            Version: {{ os.versions[0].v }}
          </div>
        </div>

      </div>
    </div>
  </label>
</template>

<script>
import BitButton from '@/components/common/button';
import BitOSIcon from '@/components/portal/osicon';

export default {
  name: 'OSRadioButton',
  components: {
    BitButton,
    BitOSIcon,
  },
  props: {
    name: {
      type: String,
      required: true
    },
    os: {
      type: Object,
      required: true
    },
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    radioButtonValue: {
      get: function() {
        return {
          name: this.os.name,
          title: this.os.title,
          version: {
            v: this.selectedVersion.v,
            osType: this.selectedVersion.osType
          }
        }
      },
      set: function() {
        // communicate change to parent component
        this.$emit("change", {
          name: this.os.name,
          title: this.os.title,
          version: {
            v: this.selectedVersion.v,
            osType: this.selectedVersion.osType
          }
        })
      }
    }
    // shouldBeChecked() {
    //   return this.os ==
    // }
  },
  data() {
    return {
      selectedVersion: ""
    }
  },
  methods: {
    init() {
      this.selectedVersion = this.os.versions[0]
    },
    onVersionChange() {
      this.$emit("change", {
        name: this.os.name,
        title: this.os.title,
        version: {
          v: this.selectedVersion.v,
          osType: this.selectedVersion.osType
        }
      })
    }
  },
  mounted() {
    this.init();
  }
}
</script>

<style scoped lang="less">
@import "../../assets/less/theme.less";

.uk-card {
  border: 1px solid rgba(0,0,0,0.1);
  cursor: pointer;

  &:hover {
    background-color: #fff;
    border: 1px solid rgba(@ba-purple, 0.5);
  }
  h3 {
    margin-top: 10px;
  }

  .uk-card-footer {
    border-top: 1px solid @ba-off-white;
  }
}

label {
  input {
    display: none;

    &:checked ~ .uk-card {
      background-color: #fff;
      border: 1px solid rgba(@ba-purple, 1);
    }
  }
}

.single-version {
  color: #333 !important;
  display: inline-block;
  font-size: 16px;
  line-height: 40px;
  text-align: center;
  padding: 0 30px;
}

</style>
